import React from 'react';
import { Button } from 'components/Ui';
import styles from './styles.scss';

const FinishView = () => (
  <div className={styles.finishView}>
    <div className={styles.background} />
    <div className={styles.btns}>
      <Button href="/products" text="See products" />
      <Button href="/get-started" text="Contact us" />
    </div>
  </div>
);

export default FinishView;
